import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateSegmentPostBody, Sector, Segment } from './sector.model';
import { withCache } from '@ngneat/cashew';

@Injectable({
  providedIn: 'root'
})
export class SectorService {
  readonly #http = inject(HttpClient);
  readonly #sectorUrl = `${environment.authHost}/api/sector/`;

  getSectors(query: string) {
    return this.#http.get<Sector[]>(this.#sectorUrl, {
      params: {
        query
      },
      context: withCache()
    });
  }

  getSegments(sectorId: number) {
    return this.#http.get<Segment[]>(`${this.#sectorUrl}/${sectorId}/segment/`);
  }

  createSegment(data: CreateSegmentPostBody) {
    return this.#http.post<Segment>(`${environment.authHost}/api/request/create/`, data);
  }
}
